<template>
  <v-app-bar app>
    <v-toolbar-title class="headline text-uppercase">
      <v-btn type="button" @click="goHome" text>AAM POC Dashboard</v-btn>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items v-if="getAuditEvent !== null">
      <v-btn type="button" @click="logOut" text>Log Out</v-btn>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import { mapActions } from "vuex";
export default {
  methods: {
    ...mapActions({
      setAuditEvent: "setAuditEvent",
      setAuditorID: "setAuditorID"
    }),
    logOut() {
      this.setAuditEvent(null);
      this.setAuditorID(null);
      this.$router.push("/");
    },
    goHome() {
      this.$router.push("/");
    }
  },
  computed: {
    getAuditEvent() {
      return this.$store.getters.getAuditEvent;
    }
  }
};
</script>

<style>
</style>


